import { render } from "./App.vue?vue&type=template&id=07c9d004"
const script = {}

import "./App.vue?vue&type=style&index=0&id=07c9d004&lang=scss"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__